import React, { useState, useEffect, useRef } from 'react'
import classNames from 'classnames'
import { Route, useLocation } from 'react-router-dom'
import { CSSTransition } from 'react-transition-group'

import { AppTopbar } from './AppTopbar'
import { AppFooter } from './AppFooter'
import { AppMenu } from './AppMenu'
import { AppConfig } from './AppConfig'

import { Dashboard } from './components/Dashboard'
import { Login } from './pages/Login'

import { CrudCompany } from './pages/CrudCompany'
import { CrudUser } from './pages/CrudUser'
import { CrudCayxYDevices } from './pages/CrudCayxYDevices'
import { CrudCayxScales } from './pages/CrudCayxScales'
import { CrudCalyxWaterMeters } from './pages/CrudCalyxWaterMeters'
import { CrudEController } from './pages/CrudEController'
import { CrudProducts } from './pages/CrudProducts'
import { CrudContracts } from './pages/CrudContracts'
import { CrudDeals } from './pages/CrudDeals'
import { CrudLogs } from './pages/CrudLogs'

import PrimeReact from 'primereact/api'
import { Tooltip } from 'primereact/tooltip'
import { ProgressBar } from 'primereact/progressbar'
import { useStore } from './stores/GlobalStore'
/**
 * need to use @tanstack/react-query-devtools@4.0.11-beta.0 instead of @tanstack/react-query-devtools until they update the beta one to the next version,
 * see https://github.com/TanStack/query/issues/3916#issuecomment-1213172411
 */
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { useIsFetching, useIsMutating } from '@tanstack/react-query'
import 'primereact/resources/primereact.css'
import 'primeicons/primeicons.css'
import 'primeflex/primeflex.css'
import 'prismjs/themes/prism-coy.css'
import './assets/demo/flags/flags.css'
import './assets/demo/Demos.scss'
import './assets/layout/layout.scss'
import './App.scss'


const App = () => {
  const [layoutMode, setLayoutMode] = useState('static')
  const [layoutColorMode, setLayoutColorMode] = useState('light')
  const [inputStyle, setInputStyle] = useState('outlined')
  const [ripple, setRipple] = useState(true)
  const [staticMenuInactive, setStaticMenuInactive] = useState(false)
  const [overlayMenuActive, setOverlayMenuActive] = useState(false)
  const [mobileMenuActive, setMobileMenuActive] = useState(false)
  const [mobileTopbarMenuActive, setMobileTopbarMenuActive] = useState(false)
  const copyTooltipRef = useRef()
  const location = useLocation()
  const { state, dispatch } = useStore()
  const isFetching = useIsFetching()
  const isMutating = useIsMutating()

  PrimeReact.ripple = true

  let menuClick = false
  let mobileTopbarMenuClick = false

  useEffect(() => {
    // check login status
    console.log(`current state = ${JSON.stringify(state)}`)
    // dispatch({ type: 'ADD', payload: 'new todo' })

    if (mobileMenuActive) {
      addClass(document.body, 'body-overflow-hidden')
    } else {
      removeClass(document.body, 'body-overflow-hidden')
    }
  }, [mobileMenuActive])

  useEffect(() => {
    copyTooltipRef && copyTooltipRef.current && copyTooltipRef.current.updateTargetEvents()
  }, [location])

  const onInputStyleChange = (inputStyle) => {
    setInputStyle(inputStyle)
  }

  const onRipple = (e) => {
    PrimeReact.ripple = e.value
    setRipple(e.value)
  }

  const onLayoutModeChange = (mode) => {
    setLayoutMode(mode)
  }

  const onColorModeChange = (mode) => {
    setLayoutColorMode(mode)
  }

  const onWrapperClick = (event) => {
    if (!menuClick) {
      setOverlayMenuActive(false)
      setMobileMenuActive(false)
    }

    if (!mobileTopbarMenuClick) {
      setMobileTopbarMenuActive(false)
    }

    mobileTopbarMenuClick = false
    menuClick = false
  }

  const onToggleMenuClick = (event) => {
    menuClick = true

    if (isDesktop()) {
      if (layoutMode === 'overlay') {
        if (mobileMenuActive === true) {
          setOverlayMenuActive(true)
        }

        setOverlayMenuActive((prevState) => !prevState)
        setMobileMenuActive(false)
      } else if (layoutMode === 'static') {
        setStaticMenuInactive((prevState) => !prevState)
      }
    } else {
      setMobileMenuActive((prevState) => !prevState)
    }

    event.preventDefault()
  }

  const onSidebarClick = () => {
    menuClick = true
  }

  const onMobileTopbarMenuClick = (event) => {
    mobileTopbarMenuClick = true

    setMobileTopbarMenuActive((prevState) => !prevState)
    event.preventDefault()
  }

  const onMobileSubTopbarMenuClick = (event) => {
    mobileTopbarMenuClick = true

    event.preventDefault()
  }

  const onMenuItemClick = (event) => {
    if (!event.item.items) {
      setOverlayMenuActive(false)
      setMobileMenuActive(false)
    }
  }
  const isDesktop = () => {
    return window.innerWidth >= 992
  }

  const menu = [
    {
      label: 'Home',
      items: [{
        label: 'Dashboard (Demo)', icon: 'pi pi-fw pi-home', to: '/'
      }]
    },
    {
      label: 'Management',
      items: [
        { label: 'Company/Business', icon: 'pi pi-fw pi-building', to: '/companies' },
        { label: 'Users', icon: 'pi pi-fw pi-users', to: '/users' },
        { label: 'Calyx Devices', icon: 'pi pi-fw pi-cog', to: '/devices' },
        { label: 'Calyx Scales', icon: 'pi pi-fw pi-video', to: '/scales' },
        { label: 'Calyx Water Meters', icon: 'pi pi-fw pi-gauge', to: '/water-meters' },
        { label: 'E-Controllers', icon: 'pi pi-fw pi-power-off', to: '/econtrollers' },
      ]
    },
    {
      label: 'ERP',
      items: [
        { label: 'Products', icon: 'pi pi-fw pi-box', to: '/products' },
        { label: 'Contracts', icon: 'pi pi-fw pi-receipt', to: '/contracts' },
        { label: 'Deals', icon: 'pi pi-fw pi-shopping-cart', to: '/deals' },
      ]
    },
    // TODO:
    // {
    //   label: 'Setting',
    //   items: [
    //     /*         {label: 'Page', icon: '', to: '/setting'} */
    //   ]
    // },
    // {
    //   label: 'Log',
    //   items: [
    //     { label: 'Log', icon: '', to: '/logs' }
    //   ]
    // }
  ]

  const addClass = (element, className) => {
    if (element.classList) { element.classList.add(className) } else { element.className += ' ' + className }
  }

  const removeClass = (element, className) => {
    if (element.classList) { element.classList.remove(className) } else { element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ') }
  }

  const wrapperClass = classNames('layout-wrapper', {
    'layout-overlay': layoutMode === 'overlay',
    'layout-static': layoutMode === 'static',
    'layout-static-sidebar-inactive': staticMenuInactive && layoutMode === 'static',
    'layout-overlay-sidebar-active': overlayMenuActive && layoutMode === 'overlay',
    'layout-mobile-sidebar-active': mobileMenuActive,
    'p-input-filled': inputStyle === 'filled',
    'p-ripple-disabled': ripple === false,
    'layout-theme-light': layoutColorMode === 'light'
  })

  return (
      <div>
        <ReactQueryDevtools initialIsOpen={false} />

        {!state?.isLogin
          ? (
              <Login />
          )
          : (
            <div className={wrapperClass} onClick={onWrapperClick}>
              <Tooltip ref={copyTooltipRef} target='.block-action-copy' position='bottom' content='Copied to clipboard' event='focus' />
              {(isFetching > 0 || isMutating > 0) && <ProgressBar mode="indeterminate" className="global-progress-bar" style={{zIndex:20000, height:2, width: '100%', position: "fixed", top: 0}}/>}

              <AppTopbar
                onToggleMenuClick={onToggleMenuClick} layoutColorMode={layoutColorMode}
                mobileTopbarMenuActive={mobileTopbarMenuActive} onMobileTopbarMenuClick={onMobileTopbarMenuClick} onMobileSubTopbarMenuClick={onMobileSubTopbarMenuClick}
              />

              <div className='layout-sidebar' onClick={onSidebarClick}>
                <AppMenu model={menu} onMenuItemClick={onMenuItemClick} layoutColorMode={layoutColorMode} />
              </div>

              <div className='layout-main-container'>
                <div className='layout-main'>

                  <Route path='/' exact render={() => <Dashboard colorMode={layoutColorMode} />} />

                  <Route path='/companies' component={CrudCompany} />
                  <Route path='/users' component={CrudUser} />
                  <Route path='/devices' component={CrudCayxYDevices} />
                  <Route path='/scales' component={CrudCayxScales} />
                  <Route path='/water-meters' component={CrudCalyxWaterMeters} />
                  <Route path='/econtrollers' component={CrudEController} />
                  <Route path='/products' component={CrudProducts} />
                  <Route path='/contracts' component={CrudContracts} />
                  <Route path='/deals' component={CrudDeals} />
                  {/* <Route path='/logs' component={CrudLogs} /> */}
                </div>

                <AppFooter layoutColorMode={layoutColorMode} />
              </div>

              <AppConfig
                rippleEffect={ripple} onRippleEffect={onRipple} inputStyle={inputStyle} onInputStyleChange={onInputStyleChange}
                layoutMode={layoutMode} onLayoutModeChange={onLayoutModeChange} layoutColorMode={layoutColorMode} onColorModeChange={onColorModeChange}
              />

              <CSSTransition classNames='layout-mask' timeout={{ enter: 200, exit: 200 }} in={mobileMenuActive} unmountOnExit>
                <div className='layout-mask p-component-overlay' />
              </CSSTransition>
            </div>
          )
        }
      </div>
  )
}

export default App
